// extracted by mini-css-extract-plugin
export default {"quizCreator":"KonkurBooklets_quizCreator__izcGY","selectOptionContainer":"KonkurBooklets_selectOptionContainer__vkXCF","quizCreatorBtn":"KonkurBooklets_quizCreatorBtn__9szfk"};